



















































import Component, { mixins } from "vue-class-component";
import AxiosMixin from "../../mixins/axiosMixin";
import { Emit, Ref } from "vue-property-decorator";
import LoadingDialog from "../common/LoadingDialog.vue";
import { MedicalExpense } from "./types";
import SelectFilter, { ColumnKey } from "@/components/common/SelectFilter.vue";
import { HeaderWidthItem } from "@/types";

@Component({
  components: {
    LoadingDialog,
    SelectFilter
  }
})
export default class MedicalServiceDialog extends mixins(AxiosMixin) {
  @Ref("selectFilter") private readonly selectFilter!: SelectFilter;

  private medicalExpenses: MedicalExpense[] = [];
  private date_str = ""; //算定年月日
  private expense_type = 0; //療養費タイプ 1:基本療養費 2:精神科基本療養費 3:医療観察訪問看護基本療養費 9:管理療養費等
  private service_code = ""; //サービスコード
  private service_name = ""; //サービス名称
  private isActive = false;

  private headers: HeaderWidthItem[] = [
    {
      value: "medical_expense_code",
      text: "サービスコード",
      width: "100px",
      filter: (val: object) => this.columnFilter("medical_expense_code", val)
    },
    {
      value: "expense_short_name",
      text: "サービス名称",
      width: "200px",
      filter: (val: object) => this.columnFilter("expense_short_name", val)
    },
    {
      value: "price",
      text: "金額",
      width: "80px"
    },
    {
      value: "select",
      text: "選択",
      width: "80px"
    }
  ];
  //------------------------------------------
  // カラムフィルター
  //------------------------------------------
  private columnFilter(key: string, val: object) {
    const bret = this.selectFilter.isMatch(key, val);
    return bret;
  }
  //------------------------------------------
  // SelectFilterの選択肢
  //------------------------------------------
  private get columnKeys(): ColumnKey[] {
    return this.headers
      .filter(hditm => {
        return hditm.filter != null;
      })
      .map(hditm => {
        let type = SelectFilter.FILTER_TYPE_EDIT;
        if (hditm.filterType != null) {
          type = hditm.filterType;
        }
        let selectable = null;
        if (
          hditm.filterType === SelectFilter.FILTER_TYPE_LIST ||
          hditm.filterType === SelectFilter.FILTER_TYPE_EDIT_LIST
        ) {
          //選択肢一覧作成
          selectable = this.medicalExpenses
            .map(itm => {
              const txt = (itm as any)[hditm.value];
              return txt === "" ? SelectFilter.NO_DATA : txt;
            })
            .filter((val, idx, arr) => {
              return arr.indexOf(val) === idx;
            });
          //NO_DATAラベルを一覧の先頭に移動
          const idx = selectable.indexOf(SelectFilter.NO_DATA);
          if (idx > 0) {
            this.moveAt(selectable, idx, 0);
          }
        }
        const fkey: ColumnKey = {
          type: type,
          key: hditm.value,
          text: hditm.text,
          selectable: selectable
        };
        return fkey;
      });
  }
  //------------------------------------------
  // 配列要素の移動
  //------------------------------------------
  private moveAt(array: object[], idx: number, at: number) {
    if (idx === at || idx > array.length - 1 || at > array.length - 1) {
      return;
    }
    const value = array[idx];
    const tail = array.slice(idx + 1);
    array.splice(idx);
    Array.prototype.push.apply(array, tail);
    array.splice(at, 0, value);
  }

  //------------------------------------------
  // ダイアログオープン
  //------------------------------------------
  public open(
    date_str: string,
    expense_type: number,
    service_code: string,
    service_name: string
  ) {
    this.date_str = date_str;
    this.expense_type = expense_type;
    this.service_code = service_code;
    this.service_name = service_name;
    this.updateData();
    this.isActive = true;
  }

  //------------------------------------------
  // サービス検索
  //------------------------------------------
  private updateData() {
    this.postJsonCheck(
      window.base_url + "/api/office/medical/transmission/edit/get_service",
      {
        date_str: this.date_str,
        expense_type: this.expense_type
      },
      res => {
        this.medicalExpenses = res.data.medical_expenses;
      }
    );
  }

  //------------------------------------------
  // 選択
  //------------------------------------------
  private clickSelect(medicalService: MedicalExpense) {
    if (
      confirm(
        "「" +
          medicalService.expense_short_name +
          "」を明細行に反映します。よろしいですか？"
      )
    ) {
      this.select(medicalService);
      this.isActive = false;
    }
  }

  //------------------------------------------
  // キャンセル
  //------------------------------------------
  private clickCancel() {
    this.isActive = false;
  }

  @Emit()
  select(medicalService: MedicalExpense) {
    return medicalService;
  }
}
